import { Input, Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { InputField } from "../UserAuth/Login/Login.styles";
import { PuffLoader } from "react-spinners";
import RedCrossIcon from "../../assets/images/RedCross.svg";
import UNIVERSAL from "../../config/config";
import "./Brand.css";
import PlaceholderImage from "../../assets/images/placeholder-image.png";
import PreviewRibbonImage from "../../assets/images/preview-ribbon.png";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const Brand = ({ setShowBrandModal, isBrandData, brandData, setBrand }) => {
  const [showImageUploadSpinner, setShowImageUploadSpinner] = useState(false);
  const [uploadedImageFileName, setUploadedImageFileName] = useState("");
  const [imageFile, setImageFile] = useState(isBrandData ? brandData?.brand_logo : "");
  const [s3ImageLink, setS3ImageLink] = useState(isBrandData ? brandData?.brand_logo : "");
  const [colorSuggestion, setColorSuggestions] = useState(isBrandData ? JSON.parse(brandData?.primary_colors) : []);

  const [brandName, setBrandName] = useState(isBrandData ? brandData?.brand_name : "");
  const [brandDescription, setBrandDescription] = useState(isBrandData ? brandData?.brand_description : "");

  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (imageFile && uploadedImageFileName) {
      async function getImageS3Url() {
        setShowImageUploadSpinner(true);
        return fetch(UNIVERSAL.BASEURL_1 + "/internal/upload_image", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
          },
          body: JSON.stringify({
            filename: uploadedImageFileName,
            image: imageFile.substring(22),
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson) {
              setS3ImageLink(responseJson.url);
              setShowImageUploadSpinner(false);
            } else {
              // error
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      getImageS3Url();
    }
  }, [imageFile]);

  function handleImageFile(event) {
    const file = event.target.files[0];
    const types = ["image/webp", "image/svg+xml", "image/png", "image/jpeg"];
    if (!types.includes(file.type)) return toast("Only .png, .jpeg, .webp and .svg files are allowed.", { type: "error" });
    setUploadedImageFileName(file.name);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageFile(reader.result.toString());
    };
    reader.readAsDataURL(file);
  }

  function removeUploadedImage() {
    setImageFile("");
    setS3ImageLink("");
  }

  const canSave = [brandName, brandDescription, s3ImageLink].every(Boolean);

  function handleSetupEditBrand(e) {
    e.preventDefault();
    if (!brandName || !brandDescription || !s3ImageLink) return;
    if (canSave) {
      return fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/update_brand", {
        method: "POST",
        body: JSON.stringify({
          brand_logo: s3ImageLink,
          brand_name: brandName,
          business_id: user?.app_business_id,
          description: brandDescription,
          primary_color: colorSuggestion,
          secondary_color: [],
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson) {
            console.log(responseJson);
            setShowBrandModal(false);
            setBrand(true);
          } else {
            // error
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  useEffect(() => {
    if (s3ImageLink) {
      async function getColorSuggestion() {
        return fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/brand_color_suggestion", {
          method: "POST",
          body: JSON.stringify({
            brand_logo: s3ImageLink,
            business_user_id: user?.app_business_id,
          }),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson) {
              let primary_color_list = responseJson?.data?.primary_color_list?.slice(0, 4);
              let secondary_list = responseJson?.data?.secondary_list?.slice(0, 4);
              let data = [...primary_color_list, ...secondary_list];
              setColorSuggestions(data);
            } else {
              // error
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      getColorSuggestion();
    }
  }, [s3ImageLink]);

  return (
    <div className="brandContainer">
      <div id="brand">
        <div className="brand__left">
          <div className="brand__leftCard">
            <h3>{brandName ? brandName : "Brand name"}</h3>
            <p>{brandDescription ? brandDescription : "Brand description"}</p>
            <img className="brand__leftCardImage" src={s3ImageLink && imageFile ? s3ImageLink : PlaceholderImage} alt="brand-img" />
            <div className="brand__leftCardSkeletons">
              <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
              <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
            </div>
            <button>Your button</button>
            <div className="brand__leftCardLine"></div>
            <img className="previewRibbonImage" src={PreviewRibbonImage} alt="previewRibbon-img" />
          </div>
        </div>
        <div className="brand__right">
        {isBrandData === true &&  
          <div className="brand__crossDiv" onClick={() => setShowBrandModal(false)}>
            <img className="brand__crossImg" src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/close-circle.svg" alt="cross-icon" />
          </div>}
          <div className="brand__rightInner">
            <h1>{isBrandData === false ? "Setup your brand details" : "Edit your brand details"} </h1>
            <p className="brand__rightInnerSubHeading">{isBrandData === false ? "Add your brand name, details or logo here" : "Change your brand name, details or logo here"}</p>
            <form onSubmit={handleSetupEditBrand} className="brand__rightInnerForm">
              <input className="brand__name" type="text" placeholder="Brand Name" name="brandName" value={brandName} onChange={(e) => setBrandName(e.target.value)} />
              {brandName?.length > 0 && <p className="requireData">Provide a name for your brand</p>}
              {!brandName && <p className="warning">Brand name is required</p>}
              <textarea
                className="brand__description"
                name="brandDescription"
                cols="30"
                rows="10"
                placeholder="Brand description"
                value={brandDescription}
                onChange={(e) => setBrandDescription(e.target.value)}
              ></textarea>
              {brandDescription?.length > 0 && <p className="requireData">Provide a description for your brand</p>}
              {!brandDescription && <p className="warning">Brand description is required</p>}
              <>
                {!showImageUploadSpinner && s3ImageLink && (
                  <div className="s3UploadedImage">
                    <img className="s3Img" src={s3ImageLink} alt="step3-img1" />
                    <img className="s3ImgRedCrossIcon" onClick={removeUploadedImage} src={RedCrossIcon} alt="redcross-icon" />
                  </div>
                )}
                {showImageUploadSpinner && (
                  <div className="brand__loadingSpinner">
                    <PuffLoader size={30} color="#0F6EFF" />
                  </div>
                )}
              </>
              {!imageFile && !s3ImageLink && (
                <div className="brand__rightInnerFormImageUploader">
                  <input className="imageModalUploadImage-file" type="file" name="imageFile" accept=".jpg,.jpeg,.svg,.webp,.png" onChange={(e) => handleImageFile(e)} id="file-upload" />
                  <label className="imageModalUploadImage-btn" for="file-upload">
                    <div className="imageModalUploadImageIconDiv">
                      <img className="imageModalUploadImage-icon" src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/send-square.svg" alt="imageModalUploadImage-icon" />
                    </div>
                    <div>
                      Drop your logo here<br/>
                      <p className="helperText">Supports jpg, jpeg, png, svg and webp</p>
                    </div>
             
                  </label>
                 
                </div>
              )}
              {colorSuggestion && (
                <div className="chooseColor">
                  <p>Your brand colors picked from logo</p>
                  <div className="chooseColorDiv">
                    {imageFile && colorSuggestion?.length === 0 && <p style={{ color: "#E57373" }}>No colors could be extracted from the logo</p>}
                    {colorSuggestion &&
                      imageFile &&
                      colorSuggestion?.map((hex, index) => {
                        return (
                          <div className="btnDiv" key={index}>
                            <button style={{ backgroundColor: hex }}></button>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
              <hr className="brand__hr" />
              <div className={`brand__rightInnerBtns ${isBrandData === true ? "brand__rightInnerBtnCenter" : "brand__rightInnerBtnSpaceBetween"}`}>
                {/* {isBrandData === false && (
                  <p className="brand__rightInnerLater" onClick={() => setShowBrandModal(false)}>
                    I'll do this later
                  </p>
                )} */}
                <button className={`brand__rightInnerCompleteBtn ${canSave ? "brand__rightInnerCompleteBtnActive" : "brand__rightInnerCompleteBtnDisabled "}`} type="submit">
                  {isBrandData === false ? "Complete Setup" : "Save brand"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brand;
